const pkg = require('../package.json');
const AppEnvs = {
    prod: 'PROD',
    qa: 'QA',
    dev: 'DEV'
};

module.exports = (() => {
    const env = process.env;
    const UID = env.UID;
    const PORT = env.PORT;
    const HOST = env.HOST;
    const MEMCACHED_SERVERS = (env.MEMCACHED_SERVERS || '127.0.0.1:11211').split(',');
    const MEMCACHED_POOLSIZE = env.MEMCACHED_POOLSIZE;
    const MEMCACHED_TIMEOUT = env.MEMCACHED_TIMEOUT;
    const MEMCACHED_RETRIES = env.MEMCACHED_RETRIES;
    const MEMCACHED_FAILURES = env.MEMCACHED_FAILURES;
    const MEMCACHED_NAMESPACE = env.MEMCACHED_NAMESPACE;
    const SHELL_IMG_REF = env.SHELL_IMG_REF;
    const CDN_HOST = env.CDN_HOST;
    const SECURE_CDN_HOST = env.SECURE_CDN_HOST;
    const CDN_PATH = env.CDN_PATH;
    const DEV_STYLES = env.DEV_STYLES;
    const SCORETC_FRONTCHANNEL_HOST = env.SCORETC_FRONTCHANNEL_HOST;
    const SCORETC_BACKCHANNEL_HOST = env.SCORETC_BACKCHANNEL_HOST;

    let appEnv = '';
    if (CDN_PATH && (CDN_PATH.indexOf('qa') !== -1)) {
        appEnv = AppEnvs.qa;
    } else if (CDN_PATH && (CDN_PATH.indexOf('qa') === -1)) {
        appEnv = AppEnvs.prod;
    } else {
        appEnv = AppEnvs.dev;
    }

    const BASE_ROUTE = env.BASE_ROUTE;

    let HTTP_PROXY = env.HTTP_PROXY;
    if (HTTP_PROXY && !HTTP_PROXY.startsWith('http://')) {
        HTTP_PROXY = `http://${HTTP_PROXY}`;
    }

    const NO_PROXY = env.NO_PROXY;
    let noProxy = null;
    if (NO_PROXY) {
        // TODO: remove this line once this PR is merged: https://github.disney.com/SEESPN/chef-repo/pull/229
        noProxy = (NO_PROXY.endsWith('|*.internal.geo.espn.com')) ? NO_PROXY : `${NO_PROXY}|*.internal.geo.espn.com`;
        noProxy = noProxy.replace(/\*\./g, '.').replace(/\./g, '\\.'); // make the NO_PROXY values compatible with regex
        noProxy = `https?:\\/\\/[^\\/]*(?:${noProxy})`; // make the usable regex
    }

    return {
        uid: UID || 'app',
        port: PORT || (DEV_STYLES ? 8000 : 8080),
        host: HOST || '0.0.0.0',
        baseRoute: BASE_ROUTE || '/watch',
        apiHost: {
            sCoreTcClient: SCORETC_FRONTCHANNEL_HOST || 'cdn.espn.com/core',
            sCoreTcServer: SCORETC_BACKCHANNEL_HOST || 'glue-bc.prod.espninfra.starwave.com/core'
        },
        devStyles: DEV_STYLES || false,
        legacyServiceUrl: 'http://www.espn.com/watchespn',
        cache: {
            servers : MEMCACHED_SERVERS,
            poolSize : parseInt(MEMCACHED_POOLSIZE, 10) || 100,
            timeout : parseInt(MEMCACHED_TIMEOUT, 10) || 1000,
            retries : parseInt(MEMCACHED_RETRIES, 10) || 1,
            failures : parseInt(MEMCACHED_FAILURES, 10) || 1,
            namespace : MEMCACHED_NAMESPACE || 'vwatchwebnode:'
        },
        shellVersion: '0.333.2',
        playerVersion: pkg.dependencies['espn-web-player-bundle'] || 'latest',
        secureCdnHost: SECURE_CDN_HOST || 'https://secure.espncdn.com',
        cdnHost: CDN_HOST || 'http://a.espncdn.com',
        cdnPath: CDN_PATH ? `${CDN_PATH}/${pkg.version}` : '/dist',
        httpProxy: HTTP_PROXY || null,
        noProxy: noProxy,
        isBeta: false,
        appEnv
    };
})();



// WEBPACK FOOTER //
// ./config/env.config.js